import { Container } from "react-bootstrap";

export default function LegalInfo() {
  return (
    <Container fluid className="p-4">
      <h1>INFORMAZIONI LEGALI</h1>
      <i>Ultimo aggiornamento: 15 Luglio 2026</i>

      <p>
        La presente pagina riporta le informazioni identificative del titolare
        dell'applicazione <strong>GetMove</strong> e le note legali relative
        all'utilizzo della piattaforma, ai sensi della normativa vigente in
        materia di commercio elettronico e servizi della società
        dell'informazione.
      </p>

      <ol>
        <li>
          <p>
            <strong>TITOLARE E DATI IDENTIFICATIVI</strong>
          </p>
          <p>
            L'applicazione Get Move e i relativi servizi sono forniti da:
          </p>
          <p>
            <span>
              <strong>WebSite strategy di Giambrone Francesco</strong>
            </span>
            <br />
            <span>Corso Roma, 105</span>
            <br />
            <span>90042 Borgetto (PA) — Italia</span>
            <br />
            <span>
              Email: <strong>support@getmoveapp.com</strong>
            </span>
            <br />
            <span>Partita IVA / Codice Fiscale: 06875790823</span>
          </p>
        </li>

        <li>
          <p>
            <strong>OGGETTO DEL SERVIZIO</strong>
          </p>
          <p>
            GetMove è una piattaforma che consente agli utenti di prenotare
            campi sportivi presso le strutture affiliate, organizzare e gestire
            partite (padel, tennis, pickleball e calcetto), partecipare a tornei
            e classifiche, gestire abbonamenti e interagire con gli altri
            utenti.
          </p>
          <p>
            GetMove agisce come strumento tecnologico di intermediazione tra
            l'utente e le strutture sportive affiliate. La disponibilità dei
            campi, l'erogazione del servizio sportivo e le condizioni
            economiche applicate sono di responsabilità della singola struttura
            affiliata.
          </p>
        </li>

        <li>
          <p>
            <strong>PROPRIETÀ INTELLETTUALE</strong>
          </p>
          <p>
            Il marchio GetMove, il logo, il codice sorgente, la grafica,
            l'interfaccia, i testi e ogni altro contenuto presente
            nell'applicazione sono di proprietà esclusiva di WebSite strategy di Giambrone Francesco
            o dei rispettivi titolari e sono protetti dalla normativa
            applicabile in materia di diritto d'autore e proprietà industriale.
          </p>
          <p>
            È vietata la riproduzione, la distribuzione, la modifica o
            l'utilizzo, totale o parziale, dei contenuti dell'applicazione senza
            il preventivo consenso scritto del titolare, fatta eccezione per
            l'uso personale consentito dai presenti termini.
          </p>
          <p>
            I marchi e i loghi delle strutture affiliate e dei partner
            eventualmente presenti nell'applicazione appartengono ai rispettivi
            titolari e sono utilizzati con la loro autorizzazione.
          </p>
        </li>

        <li>
          <p>
            <strong>LIMITAZIONE DI RESPONSABILITÀ</strong>
          </p>
          <p>
            WebSite strategy di Giambrone Francesco si impegna a garantire la corretta funzionalità
            della piattaforma, ma non garantisce che il servizio sia privo di
            interruzioni o errori. Nei limiti consentiti dalla legge, il
            titolare non risponde di danni derivanti da: indisponibilità
            temporanea del servizio, condotta degli utenti o delle strutture
            affiliate, infortuni o danni occorsi durante l'attività sportiva,
            inesattezza dei contenuti inseriti dagli utenti.
          </p>
          <p>
            L'utente è responsabile della veridicità dei dati forniti e del
            corretto utilizzo del proprio account.
          </p>
        </li>

        <li>
          <p>
            <strong>DOCUMENTI COLLEGATI</strong>
          </p>
          <p>
            L'utilizzo dell'applicazione è disciplinato anche dai seguenti
            documenti, che costituiscono parte integrante del rapporto con
            l'utente:
          </p>
          <ul>
            <li>
              <a href="/termini-e-condizioni-d-uso">
                Termini e Condizioni d'Uso
              </a>
            </li>
            <li>
              <a href="/privacy-policy">Privacy Policy</a>
            </li>
            <li>
              <a href="/informazioni-sulla-privacy">
                Informazioni sulla Privacy
              </a>
            </li>
          </ul>
        </li>

        <li>
          <p>
            <strong>LEGGE APPLICABILE E FORO COMPETENTE</strong>
          </p>
          <p>
            Il rapporto tra WebSite strategy di Giambrone Francesco e l'utente è regolato dalla legge
            italiana. Per le controversie con utenti qualificabili come
            consumatori è competente il foro del luogo di residenza o domicilio
            del consumatore, se ubicato in Italia. In tutti gli altri casi è
            competente in via esclusiva il foro di Palermo.
          </p>
        </li>

        <li>
          <p>
            <strong>CONTATTI</strong>
          </p>
          <p>
            Per qualsiasi richiesta di natura legale o informativa è possibile
            scrivere a <strong>support@getmoveapp.com</strong> o all'indirizzo
            postale indicato al punto 1.
          </p>
        </li>
      </ol>
    </Container>
  );
}
